export const APP_CODE = `// React Native App — Entry Point
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import HomeScreen from './screens/HomeScreen';
import ProfileScreen from './screens/ProfileScreen';

const Stack = createStackNavigator();

export default function App() {
  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{
          headerStyle: { backgroundColor: '#0a0b0f' },
          headerTintColor: '#00e5ff',
          headerTitleStyle: { fontWeight: '800' },
        }}
      >
        <Stack.Screen name="Home" component={HomeScreen} />
        <Stack.Screen name="Profile" component={ProfileScreen} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}`;

export const MANIFEST_CODE = `{
  "name": "MyReactApp",
  "displayName": "My React App",
  "version": "1.0.0",
  "versionCode": 1,
  "buildType": "release",
  "android": {
    "package": "com.myapp.reactnative",
    "targetSdkVersion": 34,
    "minSdkVersion": 21,
    "compileSdkVersion": 34,
    "permissions": [
      "INTERNET",
      "ACCESS_NETWORK_STATE",
      "CAMERA",
      "READ_EXTERNAL_STORAGE"
    ]
  },
  "signingConfig": {
    "storeFile": "release.keystore",
    "keyAlias": "myapp-key"
  }
}`;

export const ARCH_CODE = `# Project Architecture
src/
├── components/
│   ├── layout/       # Navbar, Sidebar, Footer
│   ├── ui/           # Button, Badge, Chip, Toggle
│   └── features/     # BuildConsole, DropZone, StatWidget
├── pages/
│   ├── DashboardPage.tsx
│   ├── EditorPage.tsx
│   ├── ApkBuilderPage.tsx
│   ├── ConverterPage.tsx
│   └── ArchitecturePage.tsx
├── hooks/
│   ├── useBuild.ts
│   ├── useEditor.ts
│   └── useSidebar.ts
├── services/
│   ├── buildService.ts
│   └── storageService.ts
├── store/
│   └── appStore.ts
├── utils/
│   ├── constants.ts
│   ├── formatters.ts
│   └── codeTemplates.ts
├── theme/
│   └── index.ts
├── types/
│   └── index.ts
└── styles/
    ├── globals.css
    └── variables.css`;

export const STYLES_CODE = `:root {
  --bg: #0a0b0f;
  --surface: #12141a;
  --surface2: #1a1d26;
  --border: #252836;
  --accent: #00e5ff;
  --accent2: #7c3aed;
  --text: #e2e8f0;
  --text-muted: #64748b;
  --success: #10b981;
  --error: #ef4444;
  --warning: #f59e0b;
  --font-sans: 'Syne', sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
  --sidebar-width: 260px;
  --nav-height: 64px;
}`;

export const CODE_MAP: Record<string, string> = {
  app: APP_CODE,
  manifest: MANIFEST_CODE,
  arch: ARCH_CODE,
  styles: STYLES_CODE,
};
